<div class="backgroung-Image inner-page-main">
    <div *ngIf="!isSpinnerLoads; else SpinnerLoads">
        <ng-container *ngIf="!registerUserClicked">
            <div class="register-container">
                <div class="ciam-container self-registeration">
                <div class="lt-fr-row event-name">
                    <label>{{'CP_SM_SELFREGISTER_EVENTNAME' | customTranslation: translationData }}</label>
                    <h1>{{userInfo.eventInfo.eventName}}</h1>
                </div>
                <div class="lt-fr-row user-info">
                    <label>{{'CP_SM_CIAMCONFIRMPAGE_MERCEDESID' | customTranslation: translationData }}</label>
                    <p> {{userInfo.ciamInfo.email}} </p>
                </div>
                <div class="lt-fr-row user-info">
                    <label>{{'CP_SM_SELFREGISTER_PARTICIPANTFNAME' | customTranslation: translationData }}</label>
                    <p>{{userInfo.ciamInfo.firstName}}</p>
                </div>
                <div class="lt-fr-row user-info">
                    <label>{{'CP_SM_SELFREGISTER_PARTICIPANTLNAME' | customTranslation: translationData }}</label>
                    <p>{{userInfo.ciamInfo.lastName}}</p>
                </div>
                <div class="lt-fr-row info-messages">
                    <span>{{'CP_SM_REGISTER_MSG' | customTranslation: translationData}}</span>    
                    <span>{{'CP_SM_REGISTER_NAME_MSG' | customTranslation: translationData}}</span> 
                </div>
                <div class="terms-conditions">
                    <input type="checkbox" name="accept" required class="checkinput" [(ngModel)]="isChecked">
                    <a target="_blank" (click)=openTermsConditions()>{{'CP_SM_TERMS_CONDITIONS' | customTranslation: translationData}}</a>
                </div>
            </div>
            <div class="ciam-container self-registeration">
                <div class="button-region">
                    <button class="primary full-w" (click)="register()" [disabled]="!isChecked" [ngClass]="{'disableButton': !isChecked}">
                        <span>{{'CP_SM_CONFIRM_BTN' | customTranslation: translationData }}</span>
                    </button>
                </div>
                <div class="lt-fr-row">
                    <div class="log-out-link" (click)="logout()">
                        <span>{{'CP_SM_CIAMCONFIRMPAGE_CONNECTMERCEDESMEID' | customTranslation: translationData
                            }}</span>
                    </div>
                </div>
            </div>
            </div>
        </ng-container>
        <div *ngIf="registerUserClicked" class="response-container">
            <app-response-page [success]="successResponse" [responseMessage]="responseMessage" [responseInfoMessage]="responseInfoMessage"></app-response-page>
            <div class="close-button-region" [hidden]="true">
                <button class="primary full-w">
                    <span>{{'CP_SM_CLOSE_BTN' | customTranslation: translationData }}</span>
                </button>
            </div>
            <div class="lt-fr-row">
                <div class="log-out-link" (click)="logout()">
                    <span>{{'CP_SM_CIAMCONFIRMPAGE_CONNECTMERCEDESMEID' | customTranslation: translationData
                        }}</span>
                </div>
            </div>
            </div>
    </div> 
</div>
<ng-template #SpinnerLoads>
    <app-spinner-component></app-spinner-component>
</ng-template>
